import { isEmpty } from 'lodash';
import React from 'react';

import appleBlackLogoSrc from '../../../../assets/images/apple_black_logo.svg';

export default function MarketingLeadCaptureWithApple({
  eventName,
  returningUri,
  verificationUri,
  formLocation,
}: {
  eventName: string;
  formLocation: string;
  leadType: string;
  returningUri?: string;
  verificationUri: string;
}) {
  const appleId = window['AppleID'];
  const appleIdScriptLoaded = !isEmpty(appleId);

  if (!appleIdScriptLoaded) return null;

  return (
    <button
      id="apple-btn-container"
      className="flex items-center h-40 px-12 border border-solid w-[250px] rounded-4 relative overflow-hidden btn-google-signin"
      data-event-name={eventName}
      data-verification-uri={verificationUri}
      data-return-uri={returningUri}
      data-form-location={formLocation}
      data-page={window.location.pathname}
      onClick={() => appleId.auth.signIn()}
    >
      {/* empty div below is used for google sign in styling */}
      <div className="absolute inset-0"></div>
      <img src={appleBlackLogoSrc} className="w-[18px] relative" />
      <div className="grow font-google-signin relative">Continue with Apple</div>
    </button>
  );
}
